var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import throttle from 'lodash/throttle';
import * as React from 'react';
import ImageLoader from '../image-loader';
import Popover from '../popover';
import { PopoverStyled, Styled } from './style';
var ItemsPreview = /** @class */ (function (_super) {
    __extends(ItemsPreview, _super);
    function ItemsPreview(props) {
        var _this = _super.call(this, props) || this;
        _this.updateDimensions = function () {
            _this.setState({ height: window.innerHeight, width: window.innerWidth });
        };
        _this.state = {
            width: window.innerWidth,
            height: window.innerHeight,
        };
        _this.handleClickThrottled = throttle(_this.updateDimensions, 500);
        return _this;
    }
    ItemsPreview.prototype.componentDidMount = function () {
        this.updateDimensions();
        window.addEventListener('resize', this.handleClickThrottled);
    };
    ItemsPreview.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleClickThrottled);
        this.handleClickThrottled.cancel();
    };
    ItemsPreview.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, content = _a.content, isInPicker = _a.isInPicker, circle = _a.circle;
        var width = this.state.width;
        var previewItemBreak = width > 2559 ? (circle ? 9 : 20) : width > 1919 ? (circle ? 9 : 12) : width > 1599 ? (circle ? 6 : 8) : width > 1151 ? (circle ? 4 : 6) : 4;
        var showThumbnail = content.slice(0, isInPicker ? 4 : previewItemBreak);
        var previewLeftMargin = 0;
        var previewContents = showThumbnail.map(function (item, index) {
            previewLeftMargin = index * (circle ? 25 : 15);
            return (React.createElement(Popover, { key: "preview-first-row-" + index, inverted: !circle, trigger: React.createElement("div", { onClick: function (e) { return _this.props.onPreviewClick(e, item.content, item.contentType); }, className: "trigger-preview " + (circle ? 'circle' : ''), style: {
                        position: 'absolute',
                        zIndex: showThumbnail.length - index,
                        left: previewLeftMargin + 'px',
                    } },
                    React.createElement(ImageLoader, { src: item.url, title: item.contentTitle })), content: circle
                    ? item.contentTitle
                    : React.createElement(PopoverStyled, null,
                        React.createElement("img", { src: item.url, title: item.contentTitle })), className: circle ? '' : 'item-thumbnail', position: "top center" }));
        });
        return (React.createElement(Styled, { className: className },
            (content.length > previewItemBreak && !isInPicker) &&
                React.createElement("span", { className: "more-preview " + (circle ? 'circle' : ''), style: { left: previewLeftMargin + 30 + 'px' } },
                    "+",
                    content.length > 99
                        ? '99'
                        : content.length - previewItemBreak),
            previewContents));
    };
    return ItemsPreview;
}(React.Component));
export default ItemsPreview;
//# sourceMappingURL=index.js.map